import {
  SyncAction,
  SyncActionStatus,
  SyncRun,
  SyncRunsPage,
} from "@app/models/SyncAction.ts";
import {
  getPageRequest,
  getRequest,
  postRequest,
} from "@app/services/api/api.ts";

const SYNC_ACTIONS_PATH = "sync-actions";
const SYNC_RUNS_PATH = `${SYNC_ACTIONS_PATH}/runs`;
export const ACTION_PARAM = "action";

const ACTION_PATHS: Record<SyncAction, string> = {
  SEND_USERS: "users/synchronize",
  SEND_MISSIONS: "missions/publish",
  SYNC_IAM: "iam/synchronize",
  SYNC_ERP: "erp/synchronize",
  SYNC_SALESFORCE_MISSIONS: "missions/sync",
  SYNC_MISSING_AVATARS: "sync-missing-avatars",
};

export const useSyncService = () => {
  const runAction = (action: SyncAction) => {
    return postRequest(ACTION_PATHS[action]).then(
      (response) => response.data as SyncRun,
    );
  };

  const stopRun = (runId: string) => {
    return postRequest(`${SYNC_RUNS_PATH}/${runId}/stop`).then(
      (response) => response.data as SyncRun,
    );
  };

  const fetchSyncActions = () => {
    return getRequest<SyncActionStatus[]>(SYNC_ACTIONS_PATH);
  };

  const fetchSyncRuns = (
    page: number,
    size: number,
    action: SyncAction | undefined,
  ) => {
    const url = action
      ? `${SYNC_RUNS_PATH}?${ACTION_PARAM}=${action}`
      : SYNC_RUNS_PATH;
    return getPageRequest<SyncRunsPage>(url, page, size);
  };

  return {
    runAction,
    stopRun,
    fetchSyncActions,
    fetchSyncRuns,
  };
};
